import Alert24 from '../../assets/icons/24/Alert_24.vue.js';
import Error24 from '../../assets/icons/24/Error_24.vue.js';
import NotificationSuccess24 from '../../assets/icons/24/Notification_success_24.vue.js';
import Info24 from '../../assets/icons/24/Info_24.vue.js';

//
var type = Object.freeze({
  success: {
    value: 'success',
    className: '_success'
  },
  error: {
    value: 'error',
    className: '_error'
  },
  info: {
    value: 'info',
    className: '_info'
  },
  warning: {
    value: 'warning',
    className: '_warning'
  },
  text: {
    value: 'text',
    className: '_text'
  }
});
var script = {
  name: 'Notification',
  props: {
    type: {
      type: String,
      default: type.success.value
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    isShowBack: {
      type: Boolean,
      default: true
    },
    isContainer: {
      type: Boolean,
      default: true
    }
  },
  data: function () { return ({
    icon: NotificationSuccess24
  }); },
  computed: {
    classList: function classList() {
      var obj;

      return ( obj = {}, obj[type.success.className] = this.type === type.success.value, obj[type.error.className] = this.type === type.error.value, obj[type.warning.className] = this.type === type.warning.value, obj[type.info.className] = this.type === type.info.value, obj[type.text.className] = this.type === type.text.value, obj['_back-white'] = !this.isShowBack, obj._container = this.isContainer, obj );
    },

    showIcon: function showIcon() {
      return this.isShowIcon && this.type !== '';
    }

  },
  watch: {
    type: function type(value) {
      this.setIcon(value);
    }

  },

  created: function created() {
    this.setIcon(this.type);
  },

  methods: {
    setIcon: function setIcon(typeComponent) {
      switch (typeComponent) {
        case type.error.value:
          {
            this.icon = Error24;
            break;
          }

        case type.warning.value:
          {
            this.icon = Alert24;
            break;
          }

        case type.text.value:
        case type.info.value:
          {
            this.icon = Info24;
            break;
          }
      }
    }

  }
};

export default script;
